import isMobileDevice from "./isMobileDevice"

function dragScrolling(selector = ".drag-scrollable") {
  if (isMobileDevice()) return

  const elements =
    typeof selector === "string" ? document.querySelectorAll(selector) : [selector]

  elements.forEach((element) => {
    if (typeof element === "string") {
      element = document.querySelector(element)
    }
    if (!element) return

    const isExistsScrollbar =
      element.scrollHeight > element.clientHeight ||
      element.scrollWidth > element.clientWidth
    if (!isExistsScrollbar) return

    let grabbedElement = null
    let dragging = false
    let x
    let y
    let dx
    let dy

    function handleMouseMove(e) {
      if (grabbedElement) {
        dragging = true
        e.preventDefault()
        dx = e.pageX - x
        dy = e.pageY - y
        grabbedElement.scrollLeft -= dx
        grabbedElement.scrollTop -= dy
        x = e.pageX
        y = e.pageY
      }
    }

    function handleMouseDown(e) {
      // e.currentTarget.style.cssText = 'cursor: grabbing!important'
      grabbedElement = e.currentTarget
      x = e.pageX
      y = e.pageY
    }

    function handleMouseUp(e) {
      if (dragging) {
        e.preventDefault()
        e.stopPropagation()
      }
      // element.style.cursor = 'grab'
      grabbedElement = null
    }

    function handleMouseLeave(e) {
      if (dragging) {
        e.preventDefault()
        e.stopImmediatePropagation()
      }
      dragging = false
      grabbedElement = null
    }

    function handleClick(e) {
      if (!dragging) return
      e.stopImmediatePropagation()
      e.preventDefault()
      dragging = false
      grabbedElement = null
    }

    // Add the event listeners
    element.addEventListener("mousedown", handleMouseDown)
    element.addEventListener("mousemove", handleMouseMove)
    element.addEventListener("mouseup", handleMouseUp)
    element.addEventListener("mouseleave", handleMouseLeave)
    element.addEventListener("click", handleClick, true)
  })
}

export default dragScrolling
